// Dòng chi phí ↔ hoá đơn sinh ra nó: Doc Search nối bằng document id, From PO ERP
// nối bằng số hoá đơn (mỗi hoá đơn ERP chỉ một dòng — handleAddErpInvoice chặn trùng).
// File tự tải lên (source "upload") không sinh dòng nào.
export const isLinked = (doc, line) => {
  if (!doc || !line) return false;
  if (doc.source === "erp_invoice") return !!doc.inv_no && String(line.inv_no || "").trim() === doc.inv_no;
  if (doc.source !== "doc_search") return false;
  const docId = doc.document_id || doc.doc_platform_document_id;
  return !!docId && line.doc_platform_document_id === docId;
};

export const linkedLineIndex = (items, doc) => (items || []).findIndex((line) => isLinked(doc, line));

export const linkedDocIndex = (docs, line) => (docs || []).findIndex((doc) => isLinked(doc, line));
